module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-1-f26d674eb364ccf4932a1146ffbe6220.jpg";